module.exports = __webpack_public_path__ + "static/media/75-beach.fd7910fd.jpg";